<!-- <mat-sidenav-container idle (onInactive)="onInactive()"> -->
<mat-sidenav-container>
  <mat-sidenav
    #mainSidenav
    class="Sidenav Sidenav--left !rounded-tr-2xl"
    mode="side"
    [opened]="canViewSidenav$ | async"
    [fixedInViewport]="true"
  >
    <aw-sidenav *ngIf="canViewSidenav$ | async" [nav]="mainSidenav"></aw-sidenav>
  </mat-sidenav>
  <div class="Main">
    <aw-topbar [nav]="mainSidenav"></aw-topbar>
    <div class="Content">
      <router-outlet></router-outlet>
    </div>
  </div>
</mat-sidenav-container>

<app-spotlight></app-spotlight>
